import { PageSize } from '../_utils';
import { PageableModel } from './generic';

export class LoadAllPageable extends PageableModel {
  constructor(obj?: LoadAllPageable) {
    super(obj);
    this.size = obj?.size || PageSize.loadAll;
  }
}
